import React from 'react';
import { useConfiguration } from "src/hooks/Configuration"
import { Image } from "../../styles"
import SpeakerModal from "../../../SpeakersWidget/modules/SpeakerModal";
import { useModal } from "src/hooks/Modal";
import { websitePath } from 'src/config';


const CategoriesImages = ({  program, component_styles}) => {

               const {addModal} = useModal();
 

           const openPopup = (content) => {
    
        addModal({
            title: '', content: <SpeakerModal component_styles={component_styles} content={content}/>, key: 'popupmodal', theme: 'whiteModalMedium'
        })

    }


    return <div className="row gap-xs">
        {program?.categories?.map( category => {

return category?.image ? <Image className="scaleOnHover" title={category?.title}  src={`${websitePath}/${category?.image}`} component_styles={component_styles}/> : <></>




        })}

    </div>



}

export default CategoriesImages;